export const supportedNetworksFields = {
    AdcolonyAccount: {
        apiKey: [''],
    },
    AdmobAccount: {
        accountId: [''],
        clientId: [''],
        clientSecret: [''],
        refreshToken: [''],
    },
    AmazonAccount: {
        s3Location: [''],
        s3AccessKeyId: [''],
        s3SecretAccessKey: [''],
    },
    ApplovinAccount: {
        apiKey: [''],
        sdkKey: [''],
    },
    // empty no additional supportedNetworksFields needed
    AppodealAccount: {},
    BigoAdsAccount: {
        devId: [''],
        token: [''],
    },
    ChartboostAccount: {
        userId: [''],
        userSignature: [''],
    },
    // empty no additional supportedNetworksFields needed
    FacebookAccount: {},
    FlurryAccount: {
        apiKey: [''],
    },
    FyberAccount: {
        consumerKey: [''],
        publisherId: [''],
        secretKey: [''],
    },
    InmobiAccount: {
        accountId: [''],
        apiKey: [''],
    },
    IronSourceAccount: {
        reportingSecretKey: [''],
    },
    MobileFuseAccount: {
        publisherId: [''],
    },
    MobvistaAccount: {
        apiKey: [''],
        sKey: [''],
        secretKey: [''],
    },
    MopubAccount: {
        apiKey: [''],
        reportKey: [''],
    },
    OguryAccount: {
        reportingApiToken: [''],
    },
    PubnativeAccount: {
        reportToken: [''],
    },
    SmaatoAccount: {
        clientKey: [''],
        clientSecret: [''],
        publisherId: [''],
    },
    StartappAccount: {
        devId: [''],
        partnerId: [''],
        token: [''],
    },
    TapjoyAccount: {
        publisherReportingApiKey: [''],
    },
    TargetAccount: {
        newAccessToken: [''],
    },
    UnityAdsAccount: {
        apiKey: [''],
        organizationCoreId: [''],
    },
    VungleAccount: {
        apiKey: [''],
    },
    YandexAccount: {
        oauthToken: [''],
    },
};
